// extracted by mini-css-extract-plugin
export default {"section":"StaffingLevelsAvailability_section__hW2W5"};